import { ETH } from '../types';
export default {
  type: ETH,
  service: 'myetherwallet.com-ws',
  url: 'wss://ws.mewapi.io/eth',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
